module.exports = __webpack_public_path__ + "img/2025 Research Innovation Global Impact_Still_1.1.1_1900x1069.aea17c35.webp";